import React, { Component } from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
  
  export default class CheckboxLabels extends Component {
    constructor(props)
    {
      super(props)
      this.state = {
        key: undefined,
        checked: false
      }
      this.handleChange = this.handleChange.bind(this)
    }
  componentDidMount()
  {
    this.setState({checked: this.props.checked, key: this.props.key})
  }
    handleChange(event){
      this.setState({ checked: event.target.checked });
      this.props.ChangeCheckbox(event.target.checked)
    };
  render()
  {
    var {checked} = this.state;
    return (
        <FormControlLabel
          key={this.props.key}
          className={this.props.className}
          control={
            <Checkbox
              style={this.props.style}
              checked={checked}
              onChange={this.handleChange}
              value="checkedA"
              color="primary"
              required={this.props.required}
            />
          }
          label={this.props.label}
        />
    );
 }
}